import mutations from './doctorTemplate.mutations'
import actions from './doctorTemplate.actions'
import getters from './doctorTemplate.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
